/**
 * Calls `onEscape` once when the ESC key is pressed, then auto-cleans.
 * @param {Function} onEscape
 */
export function addEscapeKeyHandler(onEscape) {
	function handleKeydown(e) {
		if (e.key === 'Escape') {
			onEscape();
			document.removeEventListener('keydown', handleKeydown);
		}
	}

	document.addEventListener('keydown', handleKeydown);
}

/**
 * Calls `onClickOutside` when the user clicks outside `containerEl`, excluding `triggerEl`.
 * Cleans itself after first call.
 *
 * @param {HTMLElement} containerEl
 * @param {HTMLElement} triggerEl
 * @param {Function} onClickOutside
 */
export function addClickOutsideHandler(containerEl, triggerEl, onClickOutside) {
	function handleClick(e) {
		if (
			!containerEl.contains(e.target) &&
			!triggerEl.contains(e.target)
		) {
			onClickOutside();
			document.removeEventListener('click', handleClick);
		}
	}

	document.addEventListener('click', handleClick);
}